"use client"

import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ComponentConfig } from "@measured/puck"
import { HeroBannerWithBreadcrumbProps } from "../../../../../../../types/types"
import { RenderConfig } from "./RenderConfig"

export const HeroBannerWithBreadcrumb: ComponentConfig<HeroBannerWithBreadcrumbProps> = {
  label: "Tamda Group | Hero Banner With Breadcrumb",
  fields: {
    breadcrumb: {
      label: "Breadcrumb",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
    },
    image: {
      label: "Background Image",
      type: "custom",
      render: (props: any) => <MediaSelect {...props} />,
    },
    title: {
      label: "Title",
      type: "text",
    },
  },
  defaultProps: {
    breadcrumb: [
      {
        title: "Trang Chủ",
        link: "/",
      },
      {
        title: "Về Chúng Tôi",
        link: "/about-us",
      },
    ],
    image: "",
    title: "Về Chúng Tôi",
  },
  ...RenderConfig,
}

